import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
// import { ArtistsService } from "src/app/admin/artists/artists.service";
import {VenuesService} from 'src/app/admin/venues/venues.service';
import {environment} from 'src/environments/environment.prod';

@Component({
    selector: 'app-custom-endpoint-search',
    templateUrl: './custom-endpoint-search.component.html',
    styleUrls: ['./custom-endpoint-search.component.scss'],
    standalone: false
})
export class CustomEndpointSearchComponent implements OnInit {
  selectedUsers = [];
  searchUserName = '';
  dropdownUser = false;
  deployUrl;
  users;
  usersBase;
  excludeList = [];
  placeholderThumb = 'assets/img/placeholder-thumb.png';

  @Input() addMultipleUsers = false;
  @Input() excludeListIn = [];

  @Input()
  set selectedUsersIn(users: any[]) {
    // whenever parent gives us an initial list,
    // use it both as “already selected” AND to block them from the dropdown
    this.selectedUsers = users || [];
    this.excludeList = users ? [...users] : [];
  }

  @Output() usersSelected = new EventEmitter();

  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;
  @ViewChild('inputSearch') inputField: ElementRef;

  @Input() searchEndpoint!: (params: {q: string}) => Observable<any[]>;

  constructor(private venuesService: VenuesService) {}

  ngOnInit(): void {
    this.deployUrl = environment.deploy_url;
    this.excludeList = [...this.excludeListIn];
    this.getUsers(false);
  }

  resetSearch() {
    this.getUsers(false);
    this.users = this.usersBase;
    this.selectedUsers = [];
  }

  getUsers2(showDropdown = true) {
    this.venuesService.searchVenues({q: this.searchUserName}).subscribe((data: any) => {
      if (this.excludeListIn.length > 0) {
        this.users = data.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id));
        this.usersBase = this.users;
      } else {
        this.users = data;
        this.usersBase = data;
      }
      if (showDropdown) {
        this.dropdownUser = true;
      }
    });
  }

  getUsers(showDropdown = true) {
    const params = {q: this.searchUserName};

    if (!this.searchEndpoint) {
      console.error('VenuesSearchComponent: no searchFn provided');
      this.users = [];
      return;
    }

    this.searchEndpoint({q: this.searchUserName}).subscribe((data: any[]) => {
      if (this.excludeListIn.length > 0) {
        this.users = data.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id));
        this.usersBase = this.users;
      } else {
        this.users = data;
        this.usersBase = data;
      }
      if (showDropdown) {
        this.dropdownUser = true;
      }
    });
  }

  removeSelectedUser(user, index) {
    this.selectedUsers.splice(index, 1);
    this.usersSelected.emit(this.selectedUsers);

    this.excludeList = this.excludeList.filter(item => item.id !== user.id);
    this.users = [...this.usersBase.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id))];

    if (this.selectedUsers.length === 0) {
      this.resetSearch();
    }
  }

  setUser(user) {
    this.dropdownUser = false;
    this.searchUserName = '';

    if (!this.addMultipleUsers) {
      this.selectedUsers = [];
      this.excludeList = [...this.excludeListIn];
    }

    this.selectedUsers.push(user);
    this.excludeList.push(user);

    this.users = [...this.usersBase.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id))];

    this.usersSelected.emit(this.selectedUsers);
  }

  bgImage(u: any): string {
    const src = u?.thumbnail ?? u?.logo ?? u?.photo ?? this.placeholderThumb;
    return `url('${src}')`;
  }

  getImagePath() {
    return this.deployUrl + 'assets/icons/cancel-icon.svg';
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInsideDropdown = this.dropdownMenu?.nativeElement.contains(event.target);
    const clickedInsideInput = this.inputField?.nativeElement.contains(event.target);

    if (!clickedInsideDropdown && !clickedInsideInput) {
      this.dropdownUser = false;
    }
  }
}
